module.exports = __webpack_public_path__ + "media/events/showHeader-90bd4296.jpg";